<template>
    <div :class="loaderClass">
        <div></div>
        <div></div>
        <div></div>
    </div>
</template>

<script>
    export default {
        props: {
            isProcessing: { type: Boolean, default: false },
        },

        computed: {
            loaderClass() {
                return {
                    loader: true,
                    'loader--is-processing': this.isProcessing,
                }
            },
        },
    }
</script>
